import { supabase } from "@/integrations/supabase/client";
import { ManifestationData, ManifestationStep } from "@/types";

interface ContextualResponseParams {
  step: ManifestationStep;
  userMessage: string;
  manifestationData: ManifestationData;
  fallbackMessage: string;
  previousBotMessages?: string[];
  previousUserMessages?: string[];
  forcedAngle?: string;
}

export const getContextualResponse = async ({
  step,
  userMessage,
  manifestationData,
  fallbackMessage,
  previousBotMessages,
  previousUserMessages,
  forcedAngle,
}: ContextualResponseParams): Promise<string> => {
  try {
    const { data, error } = await supabase.functions.invoke("contextual-response", {
      body: {
        step,
        userMessage,
        manifestationData,
        fallbackMessage,
        previousBotMessages,
        previousUserMessages,
        forcedAngle,
      },
    });

    if (error) {
      console.error("Error calling contextual-response:", error);
      return fallbackMessage;
    }

    return data?.response || fallbackMessage;
  } catch (e) {
    console.error("Failed to get contextual response:", e);
    return fallbackMessage;
  }
};
